import { PlanEstudioI } from "interfaces/PlanEstudio";
import { ReactNode, useState } from "react";
import { Table } from "react-bootstrap";
import { PlanesRow } from "./PlanesRow";
import { PlanesDetailModal } from "../PlanesDetailModal/PlanesDetailModal";
// import { DetailModal } from '../components/DetailModal/DetailModal';

interface Props {
  elementos: PlanEstudioI[];
  renderActions?: (
    elemento: PlanEstudioI,
    onClickShowDetail: (elemento: PlanEstudioI) => void,
  ) => ReactNode;
}

export const PlanesTable = ({ elementos = [], renderActions }: Props) => {
  const [selectedElement, setSelectedElement] = useState<PlanEstudioI | null>(
    null,
  );
  const [showModal, setShowModal] = useState(false);

  const onCloseDetailModal = () => {
    setShowModal(false);
    setTimeout(() => {
      setSelectedElement(null);
    }, 400);
  };

  const onShowDetailModal = (elemento: PlanEstudioI) => {
    setSelectedElement(elemento);
    setShowModal(true);
  };

  return (
    <>
      <Table striped bordered className="table-container">
        <thead>
          <tr className="table-heading">
            <th>ID</th>
            <th>Nombre</th>
            <th>Cantidad de años</th>
            <th>Alcance</th>
            <th>Fecha publicación</th>
            <th>Diseño curricular</th>
            {/* <th>Títulos</th> */}
            {/* <th>Resoluciones</th> */}
            <th>Validez Nacional</th>
            {renderActions && <th className="text-center">Acciones</th>}
          </tr>
        </thead>
        <tbody>
          {elementos.length > 0 ? (
            elementos.map((ctEl) => (
              <PlanesRow
                key={ctEl.id}
                elemento={ctEl}
                renderActions={
                  renderActions
                    ? (e) => renderActions(e, onShowDetailModal)
                    : undefined
                }
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={renderActions ? 9 : 8}
                className="text-center table-error-message"
              >
                <p>
                  <b>No hay planes de estudio para visualizar.</b> Para poder
                  visualizar planes de estudio debes <br /> seleccionar el botón
                  agregar «Nuevo plan de estudio».
                </p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <PlanesDetailModal
        elemento={selectedElement}
        showModal={showModal}
        onClose={onCloseDetailModal}
      />
    </>
  );
};
